/* eslint ember/no-new-mixins:"off" */
import { alias } from '@ember/object/computed';
import Mixin from '@ember/object/mixin';
import { computed } from '@ember/object';
import { getTranslationTypeTranslation } from '@square/dashboard-data/utils/custom-reports/translation-type-naming';
export function appUserRailsPermissions() {
  return window.Dashboard.__container__.lookup('service:user-rails-permissions');
}
export function appIntl() {
  return window.Dashboard.__container__.lookup('service:intl');
}
export function appIntlCountry() {
  return window.Dashboard.__container__.lookup('service:intl-country');
}
function makeProperty(key = 'nameOrTranslationType') {
  return computed(`${key}.name`, `${key}.translationType`, function () {
    const name = this.get(`${key}.name`);
    const translationType = this.get(`${key}.translationType`);
    if (name !== undefined && name !== null) {
      return name;
    } else if (translationType) {
      const userRailsPermissions = appUserRailsPermissions();
      const intl = appIntl();
      const intlCountry = appIntlCountry();
      return getTranslationTypeTranslation({
        translationType,
        userRailsPermissions
      }, intl, intlCountry);
    }
    return undefined;
  });
}
export default Mixin.create({
  name: alias('displayName'),
  displayName: makeProperty('nameOrTranslationType')
});